module.exports = __webpack_public_path__ + "static/media/marshall.04057828.png";